module.exports = __webpack_public_path__ + "img/turquistyle.a782f827.jpeg";